import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { TrackableEntity } from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';

export class BtLoadDetail extends TrackableEntity {
    id: number = 0;
    loadId: number = 0;
    origin: number = 0;
    originPort: string = '';
    originName: string = '';
    originCity: string = '';
    originCityState: string = '';
    originState: string = '';
    destPortCount: string = '';
    departure: string | null = null;
    departed: boolean = false;
    totPkgs: number = 0;
    totLbs: number = 0;
    seqNo: number = 0;
    orderCount: number = 0;

    constructor(init?:Partial<BtLoadDetail>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return  BtLoadDetail.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_BTLOADDETAIL' }),
        'loadId': new DBMappingInfo({ field: 'F_LoadID', table: 'T_BTLOADDETAIL' }),
        'origin': new DBMappingInfo({ field: 'F_Origin', table: 'T_BTLOADDETAIL' }),
        'destPortCount': new DBMappingInfo({ field: 'F_Dest', table: 'T_BTLOADDETAIL' }),
        'departure': new DBMappingInfo({ field: 'F_Departure', table: 'T_BTLOADDETAIL' }),
        'departed': new DBMappingInfo({ field: 'F_Departed', table: 'T_BTLOADDETAIL' }),
        'totPkgs': new DBMappingInfo({ field: 'F_TotPkgs', table: 'T_BTLOADDETAIL' }),
        'totLbs': new DBMappingInfo({ field: 'F_TotLbs', table: 'T_BTLOADDETAIL' }),
        'seqNo': new DBMappingInfo({ field: 'F_SeqNo', table: 'T_BTLOADDETAIL' }),
    }
}